export var BOMItemType;
(function (BOMItemType) {
    BOMItemType[BOMItemType["RAW_GOOD"] = 1] = "RAW_GOOD";
    BOMItemType[BOMItemType["FINISHED_GOOD"] = 2] = "FINISHED_GOOD";
    BOMItemType[BOMItemType["REPAIR"] = 3] = "REPAIR";
    BOMItemType[BOMItemType["NOTE"] = 4] = "NOTE";
    BOMItemType[BOMItemType["SERVICE"] = 5] = "SERVICE";
})(BOMItemType || (BOMItemType = {}));
//# sourceMappingURL=bom-item-type.js.map